// extracted by mini-css-extract-plugin
export default {"root":"GreetingTitle_root__N-tFE"};